import { APP_INITIALIZER, ErrorHandler, NgModule } from "@angular/core";
import { Router } from "@angular/router";
import { BrowserModule } from '@angular/platform-browser';
import { MatNativeDateModule } from '@angular/material/core';
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { WelcomeComponent } from './screens/welcome/welcome.component';
import { SelfieComponent } from './screens/selfie/selfie.component';
import { SelfieResultComponent } from './screens/selfie-result/selfie-result.component';
import { SurveyComponent } from './screens/survey/survey.component';
import { FormComponent } from './screens/form/form.component';
import { SummaryComponent } from './screens/summary/summary.component';
import { MatButtonModule } from '@angular/material/button';
import { DeviceDetectorService } from 'ngx-device-detector';
import { HttpClientModule, } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule, FormsModule, NgControl } from '@angular/forms';
import { MessageDialogComponent } from './screens/dialog-boxes/message-dialog/message-dialog.component';
import { LoadingDialogComponent } from './screens/dialog-boxes/loading-dialog/loading-dialog.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatCardModule } from '@angular/material/card';
import * as Sentry from "@sentry/angular-ivy";

import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule} from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { WebcamModule } from 'ngx-webcam';
import { CameraComponent } from './screens/camera/camera.component';
import { MatDialogModule } from '@angular/material/dialog';
import { PrivacyCheckDialogComponent } from './screens/dialog-boxes/privacy-check-dialog/privacy-check-dialog.component';
import { GoogleAnalyticsEventsService } from './services/google-analytics-events.service';
import { SanitizeHtmlPipe } from './pipes/sanitize-html';
import { SearchPipe } from './pipes/search.pipe';
import { MatIconModule } from '@angular/material/icon';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { RedirectService } from './services/redirect.service';
import { CustomDialogComponent } from './screens/dialog-boxes/custom-dialog/custom-dialog.component';
import { UploadViewComponent } from './screens/upload-view/upload-view.component'

@NgModule({
  declarations: [
    AppComponent,
    SanitizeHtmlPipe,
    WelcomeComponent,
    SelfieComponent,
    SelfieResultComponent,
    SurveyComponent,
    FormComponent,
    SummaryComponent,
    MessageDialogComponent,
    LoadingDialogComponent,
    CameraComponent,
    PrivacyCheckDialogComponent,
    SearchPipe,
    CustomDialogComponent,
    UploadViewComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    MatButtonModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatButtonModule,
    MatDialogModule,
    MatSnackBarModule,
    HttpClientModule,
    MatProgressBarModule,
    MatCardModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    MatButtonToggleModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatNativeDateModule,
    WebcamModule,
    NgxMatSelectSearchModule
    
  ],
  entryComponents: [
    MessageDialogComponent,
    LoadingDialogComponent,
    CameraComponent,
    PrivacyCheckDialogComponent,
    CustomDialogComponent
  ],
  providers: [
    GoogleAnalyticsEventsService, 
    DeviceDetectorService,
    RedirectService,
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
